import React, { useCallback } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import relativeTime from 'dayjs/plugin/relativeTime';
import styled from 'styled-components';

import { NotificationEntity } from 'src/firebase/db/Notifications';

import StyleConfig from 'src/constants/StyleConfig';
import ReservationListItem from 'src/components/molecules/list/ReservationListItem';

dayjs.extend(relativeTime);
dayjs.locale('ja');

type Props = {
  notifications: NotificationEntity[];
  selectedIds: { id: string, selected: boolean }[];
  isAdmin?: boolean;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  onSelect: (id: string) => void;
};

const ReservationList = (props: Props) => {
  const { notifications, selectedIds, isAdmin, onEdit, onDelete, onSelect } = props;

  // 選択状態をboolで返す
  const isSelected = useCallback((id: string) => {
    const value = selectedIds.find((v) => v.id === id);
    return !!value?.selected;
  }, [selectedIds]);

  return (
    <ReservationListContainer>
      {notifications.map((notification) => (
        <div key={notification.id}>
          <ReservationListItem
            notification={notification}
            isSelected={isSelected(notification.id)}
            isAdmin={isAdmin}
            onEdit={onEdit}
            onDelete={onDelete}
            onSelect={onSelect}
          />
        </div>
      ))}
    </ReservationListContainer>
  );
};

const ReservationListContainer = styled.div`
  margin-bottom: ${StyleConfig.HELPER.M16};
  .notification-scheduled {
    font-size: 20px;
    font-weight: bold;
    color: ${StyleConfig.COLOR.PRIMARY};
  }
  .send {
    font-size: 16px;
  }
  .notification__holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: ${StyleConfig.HELPER.M8} auto;
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: ${StyleConfig.HELPER.M16} auto;
    .total__lead {
      font-size: 16px;
    }
    .count {
      font-size: 20px;
      font-weight: bold;
    }
  }
  .orders {
    > li {
      margin-bottom: ${StyleConfig.HELPER.M4};
    }
  }
`;

export default ReservationList;
